export const METRIC_ID_PROD = 96366197;
export const METRIC_ID_RC = 93396045;
export const METRIC_ID_DEV = 93396026;
export const TITLE_SITE = 'Территория цифровых решений';
export const SITE_ID = 'KKK';
